import { render, staticRenderFns } from "./selectedInvoiceSVG.vue?vue&type=template&id=372313c6"
import script from "./selectedInvoiceSVG.vue?vue&type=script&lang=js"
export * from "./selectedInvoiceSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports